module.exports = __webpack_public_path__ + "static/restaurants-98459a3499190bf6bc89da199c800818.png";